import axios from 'axios';

import { FastDetectionResponseDTO, ImageEvaluationRequestDTO, ImageEvaluationResponseDTO } from './ai.api.types';

const BASE_URL = '/api/image-ai/detect/';
const FAST_DETECT_URL = '/api/image-ai/detect/fast/';

export const base64ToFile = (dataUrl: string, filename: string = 'upload.png'): File => {
    const [header, base64] = dataUrl.split(',');
    const mimeMatch = header.match(/data:([^;]+);base64/);

    if (!mimeMatch) {
        throw new Error('Invalid data URL');
    }

    const mime = mimeMatch[1];
    const binaryString = atob(base64);
    const len = binaryString.length;
    const u8arr = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        u8arr[i] = binaryString.charCodeAt(i);
    }

    return new File([u8arr], filename, { type: mime });
};

const evaluateImage = async (abortController: AbortController | undefined, token: string, request: ImageEvaluationRequestDTO) => {
    const form = new FormData();
    const file = base64ToFile(request.image, 'image.png');

    form.append('image', file);

    const response = await axios.post<ImageEvaluationResponseDTO>(BASE_URL, form, {
        signal: abortController?.signal,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response;
};

// Detection-only endpoint (PicoDet): same multipart contract as evaluateImage, but cheaper —
// used as an alternative, switchable box source for the live tracking loop.
const detectFast = async (abortController: AbortController | undefined, token: string, request: ImageEvaluationRequestDTO) => {
    const form = new FormData();
    const file = base64ToFile(request.image, 'image.png');

    form.append('image', file);

    const response = await axios.post<FastDetectionResponseDTO>(FAST_DETECT_URL, form, {
        signal: abortController?.signal,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response;
};

export default { evaluateImage, detectFast } as const;
